"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../Buttons/index.js");
const index_js_2 = require("../utils/index.js");
require("@itwin/itwinui-css/css/header.css");
const index_js_3 = require("../DropdownMenu/index.js");
const defaultTranslations = {
    moreOptions: 'More options',
};
/**
 * Application header
 * @example
 * <Header
 *  appLogo={<HeaderLogo logo={<SvgImodelHollow />}>iTwin Application</HeaderLogo>}
 *  breadcrumbs={
 *   <HeaderBreadcrumbs items={[
 *    <HeaderButton key='project' name='Project A' />
 *    <HeaderButton key='imodel' name='IModel X' />
 *   ]} />
 *  }
 *  actions={[
 *   <IconButton><SvgNotification /></IconButton>,
 *   <DropdownMenu>
 *    <IconButton>
 *     <SvgHelpCircularHollow />
 *    </IconButton>
 *   </DropdownMenu>,
 *   <DropdownMenu menuItems={...}>
 *    <IconButton styleType='borderless'>
 *     <Avatar ... />
 *    </IconButton>
 *   </DropdownMenu>
 *  ]}
 *  isSlim
 * />
 */
const Header = (props) => {
    const { appLogo, breadcrumbs, isSlim = false, actions, userIcon, menuItems, translatedStrings, className, children, ...rest } = props;
    (0, index_js_2.useTheme)();
    const headerTranslations = { ...defaultTranslations, ...translatedStrings };
    return (React.createElement("header", { className: (0, classnames_1.default)('iui-page-header', className), "data-iui-size": isSlim ? 'slim' : undefined, ...rest },
        React.createElement("div", { className: 'iui-page-header-left' },
            appLogo,
            breadcrumbs && React.createElement("div", { className: 'iui-page-header-divider' }),
            breadcrumbs),
        children && React.createElement("div", { className: 'iui-page-header-center' }, children),
        React.createElement("div", { className: 'iui-page-header-right' },
            actions,
            userIcon,
            menuItems && (React.createElement(index_js_3.DropdownMenu, { menuItems: menuItems },
                React.createElement(index_js_1.IconButton, { styleType: 'borderless', "aria-label": headerTranslations.moreOptions },
                    React.createElement(index_js_2.SvgMoreVertical, { "aria-hidden": true })))))));
};
exports.Header = Header;
exports.default = exports.Header;
